import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 2.25A2.25 2.25 0 0 1 11.25 0h7.5C19.969 0 21 1.031 21 2.25V24h-3.75v-3.75c0-1.219-1.031-2.25-2.25-2.25a2.25 2.25 0 0 0-2.25 2.25V24H9zM2.25 4.5H7.5V24H2.25A2.22 2.22 0 0 1 0 21.75V15h3.75c.375 0 .75-.328.75-.75 0-.375-.375-.75-.75-.75H0v-3h3.75c.375 0 .75-.328.75-.75 0-.375-.375-.75-.75-.75H0V6.75A2.25 2.25 0 0 1 2.25 4.5m25.5 0C28.969 4.5 30 5.531 30 6.75V9h-3.75c-.422 0-.75.375-.75.75 0 .422.328.75.75.75H30v3h-3.75c-.422 0-.75.375-.75.75 0 .422.328.75.75.75H30v6.75A2.25 2.25 0 0 1 27.75 24H22.5V4.5zM14.625 3c-.422 0-.75.375-.75.75v1.125H12.75c-.422 0-.75.375-.75.75v.75c0 .422.328.75.75.75h1.125V8.25c0 .422.328.75.75.75h.75c.375 0 .75-.328.75-.75V7.125h1.125c.375 0 .75-.328.75-.75v-.75c0-.375-.375-.75-.75-.75h-1.125V3.75c0-.375-.375-.75-.75-.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }